import { track } from "../track";

type Params = { error: string } & (
  | {
      type: "basic";
      email: string;
    }
  | {
      type: "google";
      quiz_id?: string;
    }
);

export const trackLogInFail = (params: Params) =>
  track({ event: "log_in_fail", ...params });
